import SEO from '../seo';
import React from 'react';
import styled from 'styled-components';
import Testimonial from '../testimonial';
const TestimonialContainer = styled.div``;
const TestimonialIntroText = styled.p``;

const Testimonials = () => {
  return (
    <TestimonialContainer>
      <SEO title="Testimonials" />

      <TestimonialIntroText>
        Here’s what people have to say about me.
      </TestimonialIntroText>
      <Testimonial
        message={
          'An excellent mind at such a young age. Subhendu had been instrumental in our efforts to build amazing products. He is hardworking and understands the concepts to the core. Never shy away from asking a question and gets the task done end-to-end. It was difficult for me to believe an intern owning and delivering a piece of a product all by himself.'
        }
        person_name={'Mr. Kumar Ravi'}
        designation={'CTO, idc'}
        img_src={
          'https://ik.imagekit.io/protechtest/1580100747881_LnCm1tFEi.jfif?tr=w-1080,h-1080,fo-auto'
        }
      />
    </TestimonialContainer>
  );
};

export default Testimonials;
